import { render, staticRenderFns } from "./atividadeDialog.vue?vue&type=template&id=90dfb7ba&scoped=true"
import script from "./atividadeDialog.vue?vue&type=script&lang=js"
export * from "./atividadeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dfb7ba",
  null
  
)

export default component.exports